import { newRidgeState } from "react-ridge-state";
import { router } from "expo-router";
import { Platform } from "react-native";
import { useEffect } from "react";

interface SiteSearchState {
	isOpen: boolean;
	searchResults: any;
}
const siteSearchState = newRidgeState<SiteSearchState>({
	isOpen: false,
	searchResults: null,
});

const siteSearchTermState = newRidgeState<string>("");

export function useSiteSearch() {
	const [searchState, setSearchState] = siteSearchState.use();
	const [searchTerm, setSearchTerm] = siteSearchTermState.use();

	useEffect(() => {
		if (Platform.OS === "web") {
			const urlParams = new URLSearchParams(window.location.search);
			const term = urlParams.get("term");
			if (term) {
				setSearchTerm(term);
			}
		}
	}, []);

	const open = () => {
		setSearchState({
			isOpen: true,
			searchResults: searchState.searchResults,
		});
	};

	const close = () => {
		setSearchState({
			isOpen: false,
			searchResults: searchState.searchResults,
		});
	};

	const setResults = (results: any) => {
		setSearchState({
			isOpen: searchState.isOpen,
			searchResults: results,
		});
	};

	const handleSetSearchTerm = (term: string) => {
		setSearchTerm(term);
		if (Platform.OS === "web" && window.location.pathname === "/search") {
			const newUrl = new URL(window.location.href);
			newUrl.searchParams.set("term", term);
			window.history.pushState({}, "", newUrl.toString());
		}
	};

	return { isOpen: searchState.isOpen, open, close, setResults, searchResults: searchState.searchResults, searchTerm, setSearchTerm: handleSetSearchTerm };
}
